import { render, staticRenderFns } from "./ed-register-basic-info.component.vue?vue&type=template&id=6910cb09&scoped=true&"
import script from "./ed-register-basic-info.component.ts?vue&type=script&lang=ts&"
export * from "./ed-register-basic-info.component.ts?vue&type=script&lang=ts&"
import style0 from "./ed-register-basic-info.component.scss?vue&type=style&index=0&id=6910cb09&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6910cb09",
  null
  
)

export default component.exports